export const masks = {
  'cpf': '000.000.000-00',
  'cnpj': '00.000.000/0000-00',
  'date': '00/00/0000',
  'mobilePhoneNumber': '(00) 00000-0000',
  'phoneNumber': '(00) 0000-0000',
  'cep': '00000-000',
  'creditCardNumber': '0000 0000 0000 0000',
  'creditCardSecurityCode': '0000',
  'creditCardValidityMonth': '00',
  'creditCardValidityYear': '00',
  'creditCardValidityMonthYear': '00/00',
  'pisPasep': '000.00000.00-0',

  'visa': '0000 0000 0000 0000',
  'mastercard': '0000 0000 0000 0000',
  'diners-club': '0000 000000 0000',
  'american-express': '0000 000000 00000',
  'discover': '0000 0000 0000 0000',
  'hipercard': '0000 0000 0000 0000',
  'maestro': '0000 0000 0000 0000',
  'elo': '0000 0000 0000 0000',
  'jcb': '0000 0000 0000 0000',
  'aura': '0000 0000 0000 0000',
};
